export default __webpack_public_path__ + "static/media/DSC01708-edit.dd602793.jpg";